<template>
<b-sidebar
    id="cat-form-sidebar"
    :visible="isCatagoryFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(categoryData)"
    @hidden="resetForm(resetData)"
    @change="(val) => $emit('update:is-catagory-form-sidebar-active', val)"
>
    <template #default="{ hide }"> 
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
            <h5 class="mb-0">
                Food Category Form
            </h5>
    
            <feather-icon
                class="ml-1 cursor-pointer"
                icon="XIcon"
                size="16"
                @click="close(hide)"
            />
        </div>
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
            <b-form
                class="p-2"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
            >
                <b-tabs content-class="mt-1" v-if="langs.length > 0">
                    <b-tab v-for="(lang,key) in langs" :key="'tab-'+key"  :title="lang.name">
                       
                        <validation-provider
                            #default="validationContext"
                            :name="'title_'+lang.code"
                            rules="min:0"
                        >
                            <b-form-group
                                label="Title"
                                :label-for="'title_'+lang.code"
                            >
                                <b-form-input
                                    :id="'title_'+lang.code"
                                    v-model="Data.title[lang.code]"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    :placeholder="'Title ('+lang.code+')'"
                                    @input="changeTitle(lang.code)"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="validationContext"
                            :name="'slug' + lang.code"
                            rules="required"
                        >
                            <b-form-group
                                label="Slug"
                                :label-for="'slug' + lang.code"
                            >
                                <b-form-input
                                    :id="'slug' + lang.code"
                                    v-model="Data.slug[lang.code]"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    :placeholder="'Slug (' + lang.code + ')'"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </b-tab>
                </b-tabs>
                <validation-provider
                    #default="validationContext"
                    name="IsActive"
                    rules="min:0"
                >
                    <b-form-group
                        label="Is Active"
                        label-for="IsActive"
                    >
                        <b-form-checkbox
                            id="isactive"
                            checked="true"
                            class="custom-control-success"
                            v-model="Data.is_active"
                            switch
                        />
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
                <div class="d-flex mt-2">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mr-2"
                        type="submit"
                    >
                        Submit
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        type="button"
                        variant="outline-secondary"
                        @click="close(hide)"
                    >
                        Cancel
                    </b-button>
                </div>
            </b-form>
        </validation-observer>
    </template>
</b-sidebar>
</template>

<script>
    import {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs,BTab
    } from 'bootstrap-vue'
    import { required, alphaNum, email, password,confirmed } from '@validations'
    import Ripple from 'vue-ripple-directive'
    import { ref,onUnmounted } from '@vue/composition-api'
    import formValidation from '@core/comp-functions/forms/form-validation'
    import languagesStoreModule from '@/views/languages/languagesStoreModule'
    import vSelect from 'vue-select'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import store from '@/store'
    import { slugify } from '@/@fake-db/utils'
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    import { useToast } from "vue-toastification/composition";

    export default {
        components: {
            BSidebar,
            BForm,
            BFormGroup,
            BFormInput,
            BFormCheckbox,
            BFormInvalidFeedback,
            BButton,
            vSelect,
            BTabs,
            BTab,
            ValidationProvider,
            ValidationObserver,
        },

        directives: {
            Ripple,
        },

        model: {
            prop: 'isCatagoryFormSidebarActive',
            event: 'update:is-catagory-form-sidebar-active',
        },

        props: {
            isCatagoryFormSidebarActive: {
                type: Boolean,
                required: true,
            },
            categoryData: {
                type: Object,
                required: false,
            },
        },

        setup(props, { emit }){
            const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
            if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
            onUnmounted(() => {
                if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
            });

            const toast = useToast();
            const userStorage = JSON.parse(localStorage.getItem('userData'));
            const getLocalSite = JSON.parse(localStorage.getItem('site'))
            const langs = ref([]);
            const blankData = {
                created_by: userStorage.id,
                slug: {},
                title: {},
                is_active: true,
                parent: 0,
                ordering_count: 0,
                sites_id: getLocalSite.id
            }
            const oldValue  =  ref(null)
            // const hide = ref(true)
            const Data = ref(blankData)
            const tabIndex = ref(0);

            const resetData = () => {
                Data.value = blankData
            }

            const close = (hidden) => {
                
                for(const lang in oldValue.value?.title ?? {}) {
                    Data.value.title[lang] = oldValue.value.title[lang]
                }

                 for(const lang in oldValue.value?.slug ?? {}) {
                    Data.value.slug[lang] = oldValue.value.slug[lang]
                }

                hidden()
            }

            const changeTitle  = (lang) => {
                if(lang){
                    Data.value.slug[lang] = slugify(Data.value.title[lang]);
                }
            }

            const getData = async (data) => { 
                tabIndex.value = 0;
                if(data) {
                    data.is_active = data.is_active? true: false
                    Data.value = data
                    oldValue.value = JSON.parse(JSON.stringify({...data}))
                } else {
                    Data.value.slug = {},
                    Data.value.title = {},
                    Data.value.is_active = true,
                    Data.value.parent = 0,
                    Data.value.ordering_count = 0
                }
            }

            const onSubmit = async () => {
                if(Data.value.id === undefined){
                    store.dispatch('app-food/addCategory', Data.value).then((res) => {
                        if(res.data.success){
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `Success`,
                                    icon: 'BellIcon',
                                    variant: 'success',
                                    text: `${res.data.message}`,
                                },
                            });
                            emit('refetch-data')
                            emit('update:is-catagory-form-sidebar-active', false)
                            Data.value = blankData
                            Data.value.title = {}
                            Data.value.slug = {}
                         
                        } else {
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `Error`,
                                    icon: 'BellIcon',
                                    variant: 'danger',
                                    text: `${res.data.message}`,
                                },
                            });
                        }
                    })
                } else {
                    store.dispatch('app-food/updateCategory', Data.value).then((res) => {
                        if(res.data.success){
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `Success`,
                                    icon: 'BellIcon',
                                    variant: 'success',
                                    text: `${res.data.message}`,
                                },
                            });
                            emit('refetch-data')
                            emit('update:is-catagory-form-sidebar-active', false)
                        } else {
                            toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `Error`,
                                    icon: 'BellIcon',
                                    variant: 'danger',
                                    text: `${res.data.message}`,
                                },
                            });
                        }
                    })
                }
                
            }

            const getLangs = (filter)=>{
                store.dispatch('app-languages/fetchData', filter)
                    .then((res) => {
                        if(res.data.success){
                            langs.value = res.data.data;
                        }  
                });
            }

            let filter = {
                is_active: 1
            }

            getLangs(filter);

            const refeshList = async () => {
                emit("refetch-data");
            };

            const {
                refFormObserver,
                getValidationState,
                resetForm,
            } = formValidation(resetData)

            return {
                getData,
                refFormObserver,
                getValidationState,
                resetForm,
                langs,
                onSubmit,
                changeTitle,
                Data,
                refeshList,
                resetData,
                tabIndex,
                close
            }
        }
    }
</script>